var _g, _g2, _g3, _polygon, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _path, _rect, _polygon2, _polygon3, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVsdx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    enableBackground: "new 0 0 96 96",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TEMPLATE",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D0D0D0",
    d: "M96,0v96H0V0H96 M97-1h-1H0h-1v1v96v1h1h96h1v-1V0V-1L97-1z"
  })), /*#__PURE__*/React.createElement("g", {
    display: "inline",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF3A6D",
    d: "M90,6v84H6V6H90 M96,0H0v96h96V0L96,0z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ICONS"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "86,88 26,88 26,8 68,8 86,26  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#949494",
    d: "M68.001,6H24v84h64V26L68.001,6z M68,9l17,17H68V9z M86,88H26V8h40v20h20V88z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M52,54v10H42V54H52 M54,52H40v14h14V52L54,52z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#3955A3",
    points: "8,34 48,28 48,80 8,74  "
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M73,68c2.7568,0,5,2.2432,5,5s-2.2432,5-5,5s-5-2.2432-5-5S70.2432,68,73,68 M73,66 c-3.8662,0-7,3.1338-7,7s3.1338,7,7,7s7-3.1338,7-7S76.8662,66,73,66L73,66z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M63,36c2.7568,0,5,2.2432,5,5s-2.2432,5-5,5s-5-2.2432-5-5S60.2432,36,63,36 M63,34 c-3.8662,0-7,3.1338-7,7s3.1338,7,7,7s7-3.1338,7-7S66.8662,34,63,34L63,34z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#C8C8C8",
    points: "74,58 54,58 54,60 74,60 74,58  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#C8C8C8",
    points: "74,58 72,58 72,68 74,68 74,58  "
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#C8C8C8",
    points: "64,46 62,46 62,60 64,60 64,46  "
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M33,14c-0.5527,0-1,0.4473-1,1s0.4473,1,1,1s1-0.4473,1-1S33.5527,14,33,14L33,14z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M39,14c-0.5527,0-1,0.4473-1,1s0.4473,1,1,1s1-0.4473,1-1S39.5527,14,39,14L39,14z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M39,20c-0.5527,0-1,0.4473-1,1s0.4473,1,1,1s1-0.4473,1-1S39.5527,20,39,20L39,20z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M45,14c-0.5527,0-1,0.4473-1,1s0.4473,1,1,1s1-0.4473,1-1S45.5527,14,45,14L45,14z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M51,14c-0.5527,0-1,0.4473-1,1s0.4473,1,1,1s1-0.4473,1-1S51.5527,14,51,14L51,14z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M57,14c-0.5527,0-1,0.4473-1,1s0.4473,1,1,1s1-0.4473,1-1S57.5527,14,57,14L57,14z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M79,36c-0.5527,0-1,0.4473-1,1s0.4473,1,1,1s1-0.4473,1-1S79.5527,36,79,36L79,36z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M79,42c-0.5527,0-1,0.4473-1,1s0.4473,1,1,1s1-0.4473,1-1S79.5527,42,79,42L79,42z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M79,48c-0.5527,0-1,0.4473-1,1s0.4473,1,1,1s1-0.4473,1-1S79.5527,48,79,48L79,48z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M79,54c-0.5527,0-1,0.4473-1,1s0.4473,1,1,1s1-0.4473,1-1S79.5527,54,79,54L79,54z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M79,60c-0.5527,0-1,0.4473-1,1s0.4473,1,1,1s1-0.4473,1-1S79.5527,60,79,60L79,60z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M61,78c-0.5527,0-1,0.4473-1,1s0.4473,1,1,1s1-0.4473,1-1S61.5527,78,61,78L61,78z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#C8C8C8",
    d: "M55,78c-0.5527,0-1,0.4473-1,1s0.4473,1,1,1s1-0.4473,1-1S55.5527,78,55,78L55,78z"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39,43l-8.0623,23h-5.9733L17,43h5.6795l4.8798,16.007c0.2611,0.8661,0.4187,1.631,0.4733,2.2936h0.0979 c0.076-0.7162,0.2448-1.5022,0.5059-2.3577L33.4837,43H39z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.1734,
    y1: 11.7282,
    x2: 84.9786,
    y2: 92.5353
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2264,
    style: {
      stopColor: "#FCFCFC",
      stopOpacity: 0.0226
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3626,
    style: {
      stopColor: "#F4F4F4",
      stopOpacity: 0.0363
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    style: {
      stopColor: "#E6E6E6",
      stopOpacity: 0.0475
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5744,
    style: {
      stopColor: "#D1D1D1",
      stopOpacity: 0.0574
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6652,
    style: {
      stopColor: "#B7B7B7",
      stopOpacity: 0.0665
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7498,
    style: {
      stopColor: "#979797",
      stopOpacity: 0.075
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8297,
    style: {
      stopColor: "#707070",
      stopOpacity: 0.083
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9057,
    style: {
      stopColor: "#444444",
      stopOpacity: 0.0906
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9761,
    style: {
      stopColor: "#121212",
      stopOpacity: 0.0976
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M88,26L68,6H24v84h64V26z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 76,
    y1: 33.8125,
    x2: 76,
    y2: 28.175
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#828282",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2812,
    style: {
      stopColor: "#7F7F7F",
      stopOpacity: 0.0281
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4503,
    style: {
      stopColor: "#777777",
      stopOpacity: 0.045
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5899,
    style: {
      stopColor: "#696969",
      stopOpacity: 0.059
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7133,
    style: {
      stopColor: "#545454",
      stopOpacity: 0.0713
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    style: {
      stopColor: "#3A3A3A",
      stopOpacity: 0.0826
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9294,
    style: {
      stopColor: "#1A1A1A",
      stopOpacity: 0.0929
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.1
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 28,
    fill: "url(#SVGID_2_)",
    width: 20,
    height: 6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 62.54,
    y1: 24.46,
    x2: 74.4721,
    y2: 12.5279
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8537,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.2134
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.25
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_3_)",
    points: "24,6 24,8 66,8 66,28 86,28 86,56 88,56 88,26 68,6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.5076,
    y1: 85.8365,
    x2: 36.3547,
    y2: 77.86
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#828282",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1699,
    style: {
      stopColor: "#7E7E7E",
      stopOpacity: 0.0341
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    style: {
      stopColor: "#717171",
      stopOpacity: 0.0694
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5248,
    style: {
      stopColor: "#5D5D5D",
      stopOpacity: 0.1053
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7057,
    style: {
      stopColor: "#404040",
      stopOpacity: 0.1415
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8863,
    style: {
      stopColor: "#1B1B1B",
      stopOpacity: 0.1778
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.2
    }
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_4_)",
    points: "48,86 24,86 24,76.4 48,80  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 28,
    y1: 78.375,
    x2: 28,
    y2: 29.5168
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8587,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.1546
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0.18
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#SVGID_5_)",
    points: "48,28 8,34 8,74 48,80  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsdx);
export default __webpack_public_path__ + "static/media/vsdx.bfb1e94c59aa97d4b209449e329dd27a.svg";
export { ForwardRef as ReactComponent };